import React from 'react'

function PhysicalScience() {
  return (
    <div>PhysicalScience</div>
  )
}

export default PhysicalScience